<template>
  <div class="image-zoom" :style="`width: ${width}px; height: ${height}px;`">
    <v-zoomer
      ref="zoomer"
			:style="`width: ${width}px; height: ${height}px;`"
      :max-scale="4"
      :zoomed.sync="zoomed"
      @mousedown.native="clicked = true"
      @mouseup.native="handleClickZoom"
      @mousemove.native="handleMouseMove"
    >
      <img
        :src="image"
        style="object-fit: contain; width: 100%; height: 100%;"
      />
    </v-zoomer>
  </div>
</template>

<script>
import Vue from 'vue'
import VueZoomer from 'vue-zoomer'

Vue.use(VueZoomer)

export default {
  name: 'ImageZoom',
  props: {
    image: {
      type: String,
      default: null
    },
    width: {
      type: Number,
      default: 400
    },
    height: {
      type: Number,
      default: 300
    }
  },
  data () {
    return {
      zoomed: false,
      clicked: false,
      dragged: false
    }
  },
  methods: {
    handleClickZoom () {
      if (!this.dragged) {
        if (this.$refs.zoomer.scale >= this.$refs.zoomer.maxScale) { this.$refs.zoomer.reset() } else this.$refs.zoomer.zoomIn()
      }
      this.clicked = false
      this.dragged = false
    },
    handleMouseMove (e) {
      const boolDelta = Math.abs(e.movementX) >= 2 || Math.abs(e.movementY) >= 2
      if (this.clicked && boolDelta) { this.dragged = true }
    }
  },
  watch: {
    image (newValue, oldValue) {
      this.$refs.zoomer.reset()
    }
  }
}
</script>

<style lang="less" scoped>
	.image-zoom {
		display: flex;
		position: relative;
		align-items: center;
		justify-content: center;
		overflow: hidden;

		img {
			cursor: url(/img/magnifier.cur), -webkit-zoom-in;
			cursor: url(/img/magnifier.cur), zoom-in;
			cursor: url(/img/magnifier.cur), zoom-in;
		}
	}
</style>
